module.exports = "/_next/static/images/privacy-16599a7bb7ad2d174677970cfb4194a6.png";